import { render, staticRenderFns } from "./Dictionaries.vue?vue&type=template&id=21896afe"
import script from "./Dictionaries.vue?vue&type=script&lang=js"
export * from "./Dictionaries.vue?vue&type=script&lang=js"
import style0 from "./Dictionaries.vue?vue&type=style&index=0&id=21896afe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports